var _g, _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPapaPointsSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 75,
    viewBox: "0 0 61 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_2719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6118 28.7113L49.2159 51.4726C48.3301 54.1967 45.8115 56.027 42.946 56.027H19.0108C16.1453 56.027 13.6266 54.1967 12.7408 51.4726L5.34494 28.7113C4.45914 25.9872 5.42231 23.023 7.74086 21.3395L27.103 7.27078C28.2609 6.42767 29.619 6.00879 30.977 6.00879C32.3351 6.00879 33.6931 6.43034 34.8537 7.27078L54.2159 21.3395C56.5344 23.023 57.4976 25.9846 56.6118 28.7113Z",
    fill: "url(#paint0_linear_118_2719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6403 18.3376L36.2894 5.00265C32.7942 2.46266 28.0957 2.46266 24.6006 5.00265L6.24697 18.3376C2.75181 20.8776 1.30038 25.344 2.63441 29.4555L9.64342 51.0321C10.9774 55.1409 14.7794 57.9023 19.1017 57.9023H41.7856C46.1078 57.9023 49.9072 55.1409 51.2439 51.0321L58.2529 29.4555C59.5896 25.3466 58.1381 20.8776 54.6403 18.3376ZM54.739 28.3135L47.73 49.8902C46.8922 52.4728 44.5017 54.2071 41.7856 54.2071H19.1017C16.3856 54.2071 13.9977 52.4728 13.1573 49.8902L6.14825 28.3135C5.31048 25.7308 6.22029 22.924 8.41878 21.3259L26.7697 7.99355C27.869 7.1958 29.155 6.79559 30.441 6.79559C31.727 6.79559 33.0156 7.1958 34.1149 7.99355L52.4685 21.3285C54.6643 22.924 55.5795 25.7335 54.739 28.3162V28.3135Z",
    fill: "url(#paint1_linear_118_2719)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_118_2719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9392 37.374C14.8965 37.7289 15.0086 38.0864 15.2487 38.3559C15.6115 38.7641 16.2145 38.8922 16.7135 38.6627L20.4034 36.9712L24.0933 38.6654C24.2587 38.7427 24.4348 38.7801 24.6163 38.7801C24.9738 38.7801 25.318 38.6254 25.5581 38.3559C25.7955 38.0891 25.9076 37.7316 25.8649 37.3767L25.3953 33.3453L28.1461 30.3597C28.4529 30.0262 28.557 29.5513 28.4182 29.119C28.2795 28.6868 27.914 28.364 27.4711 28.2733L23.4903 27.4728L21.5 23.9323C21.2785 23.5375 20.857 23.292 20.4061 23.292C19.9552 23.292 19.5309 23.5375 19.3095 23.9323L17.3191 27.4702L13.3384 28.2706C12.8928 28.3613 12.5299 28.6841 12.3912 29.1164C12.2498 29.5486 12.3538 30.0235 12.6633 30.357L15.4141 33.3453L14.9445 37.3767L14.9392 37.374Z",
    fill: "url(#paint2_linear_118_2719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9392 37.374C14.8965 37.7289 15.0086 38.0864 15.2487 38.3559C15.6115 38.7641 16.2145 38.8922 16.7135 38.6627L20.4034 36.9712L24.0933 38.6654C24.2587 38.7427 24.4348 38.7801 24.6163 38.7801C24.9738 38.7801 25.318 38.6254 25.5581 38.3559C25.7955 38.0891 25.9076 37.7316 25.8649 37.3767L25.3953 33.3453L28.1461 30.3597C28.4529 30.0262 28.557 29.5513 28.4182 29.119C28.2795 28.6868 27.914 28.364 27.4711 28.2733L23.4903 27.4728L21.5 23.9323C21.2785 23.5375 20.857 23.292 20.4061 23.292C19.9552 23.292 19.5309 23.5375 19.3095 23.9323L17.3191 27.4702L13.3384 28.2706C12.8928 28.3613 12.5299 28.6841 12.3912 29.1164C12.2498 29.5486 12.3538 30.0235 12.6633 30.357L15.4141 33.3453L14.9445 37.3767L14.9392 37.374Z",
    stroke: "url(#paint3_linear_118_2719)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_118_2719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5677 29.1137C49.4289 28.6814 49.0634 28.3586 48.6205 28.2679L44.6397 27.4675L42.6494 23.927C42.4279 23.5321 42.0064 23.2866 41.5555 23.2866C41.1046 23.2866 40.6803 23.5321 40.4589 23.927L38.4685 27.4648L34.4878 28.2652C34.0422 28.3559 33.6793 28.6788 33.5406 29.111C33.3992 29.5432 33.5032 30.0181 33.8127 30.3517L36.5635 33.3399L36.0939 37.3713C36.0513 37.7262 36.1633 38.0837 36.4034 38.3532C36.7663 38.7614 37.3693 38.8895 37.8682 38.66L41.5581 36.9684L45.2481 38.6627C45.4135 38.74 45.5896 38.7774 45.771 38.7774C46.1285 38.7774 46.4727 38.6226 46.7128 38.3532C46.9503 38.0864 47.0623 37.7288 47.0197 37.374L46.5501 33.3426L49.3009 30.357C49.6077 30.0235 49.7117 29.5486 49.573 29.1163L49.5677 29.1137Z",
    fill: "url(#paint4_linear_118_2719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5677 29.1137C49.4289 28.6814 49.0634 28.3586 48.6205 28.2679L44.6397 27.4675L42.6494 23.927C42.4279 23.5321 42.0064 23.2866 41.5555 23.2866C41.1046 23.2866 40.6803 23.5321 40.4589 23.927L38.4685 27.4648L34.4878 28.2652C34.0422 28.3559 33.6793 28.6788 33.5406 29.111C33.3992 29.5432 33.5032 30.0181 33.8127 30.3517L36.5635 33.3399L36.0939 37.3713C36.0513 37.7262 36.1633 38.0837 36.4034 38.3532C36.7663 38.7614 37.3693 38.8895 37.8682 38.66L41.5581 36.9684L45.2481 38.6627C45.4135 38.74 45.5896 38.7774 45.771 38.7774C46.1285 38.7774 46.4727 38.6226 46.7128 38.3532C46.9503 38.0864 47.0623 37.7288 47.0197 37.374L46.5501 33.3426L49.3009 30.357C49.6077 30.0235 49.7117 29.5486 49.573 29.1163L49.5677 29.1137Z",
    stroke: "url(#paint5_linear_118_2719)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 55.5,
    width: 38,
    height: 19,
    rx: 4.5,
    fill: "url(#paint6_linear_118_2719)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.276 60.2H16.56V69.692C16.56 69.888 16.672 70 16.868 70H18.772V67.116H19.276C20.732 67.116 21.978 66.346 21.978 63.658C21.978 61.138 20.732 60.2 19.276 60.2ZM18.772 65.296V62.02H18.996C19.556 62.02 19.794 62.314 19.794 63.658C19.794 65.002 19.556 65.296 18.996 65.296H18.772ZM25.0064 60.508C25.0064 60.312 24.8944 60.2 24.6984 60.2H22.7944V70H26.4064C26.6024 70 26.7144 69.888 26.7144 69.692V68.04H25.0064V60.508ZM31.6695 60.48C31.6415 60.298 31.5155 60.2 31.3335 60.2H28.3095L26.9655 69.664C26.9375 69.874 27.0355 70 27.2455 70H29.1495L29.3175 68.11H30.5915L30.7455 69.72C30.7595 69.916 30.8855 70 31.0675 70H33.0415L31.6695 60.48ZM29.7935 62.86C29.8075 62.734 29.8635 62.678 29.9475 62.678C30.0455 62.678 30.0875 62.734 30.1015 62.86L30.4235 66.234H29.4855L29.7935 62.86ZM38.1598 60.508C38.1598 60.312 38.0478 60.2 37.8518 60.2H33.2038V61.852C33.2038 62.048 33.3158 62.16 33.5118 62.16H34.5758V69.692C34.5758 69.888 34.6878 70 34.8838 70H36.7878V62.16H38.1598V60.508ZM43.0855 60.48C43.0575 60.298 42.9315 60.2 42.7495 60.2H39.7255L38.3815 69.664C38.3535 69.874 38.4515 70 38.6615 70H40.5655L40.7335 68.11H42.0075L42.1615 69.72C42.1755 69.916 42.3015 70 42.4835 70H44.4575L43.0855 60.48ZM41.2095 62.86C41.2235 62.734 41.2795 62.678 41.3635 62.678C41.4615 62.678 41.5035 62.734 41.5175 62.86L41.8395 66.234H40.9015L41.2095 62.86Z",
    fill: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 55.5,
    width: 38,
    height: 19,
    rx: 4.5,
    stroke: "url(#paint7_linear_118_2719)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_118_2719",
    x: 3.3291,
    y: 14.292,
    width: 38.1494,
    height: 37.4883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2719"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2719",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_118_2719",
    x: 24.4785,
    y: 14.2866,
    width: 38.1553,
    height: 37.4907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2719"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2719",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_2719",
    x1: 7.51941,
    y1: 57.8172,
    x2: 54.0344,
    y2: 11.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_118_2719",
    x1: 2.14349,
    y1: 30.4987,
    x2: 58.7438,
    y2: 30.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A0A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_118_2719",
    x1: 12.3272,
    y1: 31.0347,
    x2: 28.4796,
    y2: 31.0347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_118_2719",
    x1: 20.4034,
    y1: 39.0442,
    x2: 20.4034,
    y2: 23.0252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_118_2719",
    x1: 33.4766,
    y1: -0.557856,
    x2: 49.629,
    y2: -0.557856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_118_2719",
    x1: 41.5528,
    y1: 39.0442,
    x2: 41.5528,
    y2: 23.0252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_118_2719",
    x1: 11,
    y1: 65,
    x2: 50,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_118_2719",
    x1: 11,
    y1: 55,
    x2: 51.8561,
    y2: 69.9159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_2719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapaPointsSilver);
export default __webpack_public_path__ + "static/media/papa_points_silver.8c671f33d56bcc7366f8215209d1457e.svg";
export { ForwardRef as ReactComponent };